import { FiMapPin, FiGlobe, FiTool, FiUsers, FiShield, FiAward, FiSettings, FiHeadphones } from 'react-icons/fi';
import aboutUsMap from '../assets/aboutUsMap.jpeg';

const highlights = [
  {
    icon: <FiMapPin />,
    label: 'Headquarters',
    desc: 'Yangzhou, Jiangsu, China'
  },
  {
    icon: <FiGlobe />,
    label: 'Branch',
    desc: 'United States of America'
  },
  {
    icon: <FiTool />,
    label: 'Manufacturing Base',
    desc: 'Indonesia'
  },
  {
    icon: <FiUsers />,
    label: 'Marketing Territory',
    desc: '30+ Negara di Dunia'
  }
];

const features = [
  {
    icon: <FiShield />,
    title: 'Standar PLN & Internasional',
    desc: 'Produk memenuhi standar PLN dan IEC untuk keamanan dan keandalan maksimal'
  },
  {
    icon: <FiAward />,
    title: 'Sertifikasi Lengkap',
    desc: 'Dilengkapi sertifikasi PLN, ISO, dan standar mutu internasional lainnya'
  },
  {
    icon: <FiSettings />,
    title: 'Engineering & Quality Control',
    desc: 'Proses desain engineering dan quality control yang mengacu pada standar PLN dan internasional'
  },
  {
    icon: <FiHeadphones />,
    title: 'Dukungan Shuanghui Power Group',
    desc: ' Didukung oleh teknologi, keahlian engineering, serta pengalaman proyek dari Shuanghui Power Group'
  }
];

const About = () => {
  return (
    <section className="about section" id="about">
      {/* Top: Company Intro */}
      <div className="container">
        <div className="about-intro">
          <div className="about-intro-text">
            <span className="section-subtitle">About Company</span>
            <h2 className="section-title">
              Bagian dari Jaringan Global<br />
              <span className="title-accent">Shuanghui Power Group</span>
            </h2>
            <p className="section-description">
              PT Shuanghui Power Indonesia adalah produsen switchgear tegangan menengah dan rendah 
              yang menyediakan solusi kelistrikan berbasis standar PLN dan IEC. 
              Dengan fasilitas manufaktur lokal, kami memproduksi panel switchgear MV/LV 
              termasuk GIS, AIS, dan Metal-Clad untuk aplikasi industri, utilitas, dan infrastruktur.
            </p>
            <p className="section-description" style={{ marginTop: '15px' }}>
              Operasional kami didukung oleh SH Power Group, perusahaan global 
              dengan pengalaman lebih dari 30 tahun di bidang riset, produksi, 
              dan layanan peralatan distribusi tenaga listrik, yang telah berkontribusi 
              pada proyek-proyek energi di berbagai negara.
            </p>
          </div>
          <div className="about-intro-features">
            {features.map((feature, index) => (
              <div className="about-feature-card" key={index}>
                <div className="about-feature-card-icon">
                  {feature.icon}
                </div>
                <div className="about-feature-card-text">
                  <h4>{feature.title}</h4>
                  <p>{feature.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Middle: Global Network Map */}
      <div className="about-map-section">
        <div className="container">
          <div className="about-map-header">
            <span className="section-subtitle">Global Network</span>
            <h3 className="about-map-title">Jaringan Kami di Seluruh Dunia</h3>
          </div>
          <div className="about-map-wrapper">
            <img src={aboutUsMap} alt="Shuanghui Power Global Network Map" className="about-map-image" />
          </div>
          <div className="about-map-highlights">
            {highlights.map((item, index) => (
              <div className="map-highlight-item" key={index}>
                <div className="map-highlight-icon">{item.icon}</div>
                <div className="map-highlight-text">
                  <h4>{item.label}</h4>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom: Stats Bar
      <div className="hero-stats-bar">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <h3>500+</h3>
              <p>Proyek Selesai</p>
            </div>
            <div className="stat-item">
              <h3>100+</h3>
              <p>Klien Puas</p>
            </div>
            <div className="stat-item">
              <h3>10+</h3>
              <p>Tahun Pengalaman</p>
            </div>
            <div className="stat-item">
              <h3>50+</h3>
              <p>Tim Profesional</p>
            </div>
          </div>
        </div>
      </div> */}
    </section>
  );
};

export default About;
